import { interpolateRgbBasis } from 'd3-interpolate';

export const chartBaseTextStyle = {
  fill: 'var(--color-text-tertiary)',
  fontFamily: 'inherit',
  fontSize: 'var(--font-size-12)',
};

export const chartBaseTheme = {
  axis: {
    ticks: {
      line: { stroke: 'var(--color-gray-3)', strokeWidth: 1 },
      text: chartBaseTextStyle,
    },
    legend: {
      text: chartBaseTextStyle,
    },
  },
};

export const COLOR_SCALE_MATERIALS = interpolateRgbBasis(['#EB2F96', '#A0D911', '#FADB14', '#722ED1', '#98A2B3']);

export const EURAL_CHAPTER_COLOR_MAP = [
  'hsl(263, 100%, 73%)',
  'hsl(263, 71%, 57%)',
  'hsl(265, 53%, 41%)',
  'hsl(223, 100%, 29%)',
  'hsl(223, 100%, 50%)',
  'hsl(204, 87%, 51%)',
  'hsl(208, 97%, 14%)',
  'hsl(208, 100%, 20%)',
  'hsl(179, 100%, 31%)',
  'hsl(24, 100%, 27%)',
  'hsl(180, 100%, 13%)',
  'hsl(334, 82%, 63%)',
  'hsl(334, 100%, 45%)',
  'hsl(334, 100%, 36%)',
  'hsl(22, 100%, 50%)',
  'hsl(45, 100%, 35%)',
  'hsl(357, 91%, 17%)',
  'hsl(134, 67%, 16%)',
  'hsl(138, 67%, 30%)',
  'hsl(134, 100%, 34%)',
];
